export var QuotationsActionTypes;
(function (QuotationsActionTypes) {
    QuotationsActionTypes["FETCH_QUOTATIONS_ATTEMPT"] = "FETCH_QUOTATIONS_ATTEMPT";
    QuotationsActionTypes["FETCH_QUOTATIONS_SUCCESS"] = "FETCH_QUOTATIONS_SUCCESS";
    QuotationsActionTypes["FETCH_QUOTATIONS_FAILURE"] = "FETCH_QUOTATIONS_FAILURE";
})(QuotationsActionTypes || (QuotationsActionTypes = {}));
